window.Dropzone       = require('dropzone/dist/dropzone')
Dropzone.autoDiscover = false;

window.dropzoneDict                                 = {};
window.dropzoneDict['dictDefaultMessage']           = "Pre nahratie súborov ich potiahnite a pustite sem, alebo sem kliknite pre ich výber";
window.dropzoneDict['dictFallbackMessage']          = "Váš prehliadač nepodporuje nahrávanie súborov metódou drag'n'drop.";
window.dropzoneDict['dictFallbackText']             = "Prosím, použite náhradný formulár nižšie na nahratie vašich súborov ako v starých časoch.";
window.dropzoneDict['dictFileTooBig']               = "Súbor je príliš veľký ({{filesize}}MiB). Maximálna veľkosť súboru: {{maxFilesize}}MiB.";
window.dropzoneDict['dictInvalidFileType']          = "Nemôžete nahrať súbory tohto typu.";
window.dropzoneDict['dictResponseError']            = "Server odpovedal s kódom {{statusCode}}.";
window.dropzoneDict['dictCancelUpload']             = "Zrušiť nahrávanie";
window.dropzoneDict['dictCancelUploadConfirmation'] = "Ste si istí, že chcete zrušiť toto nahrávanie?";
window.dropzoneDict['dictRemoveFile']               = "Odstrániť súbor";
window.dropzoneDict['dictMaxFilesExceeded']         = "Nemôžete nahrať viac súborov.";
